var _style, _polygon, _polygon2, _path, _polygon3, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    viewBox: "350.3 426.72 299.4 146.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.252,
    y1: 495.2198,
    x2: 436.3566,
    y2: 495.2198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "436.36,540.78 407.91,540.78 407.91,455.14 407.91,437.96 395.25,445.01 395.25,462.11 395.25,552.48    436.36,552.48  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.4017,
    y1: 495.3611,
    x2: 479.881,
    y2: 495.3611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.88,540.78 462.06,540.78 462.06,462.06 462.06,445.07 449.4,438.24 449.4,455.3 449.4,552.48    479.88,552.48  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.1277,
    y1: 501.0653,
    x2: 387.6628,
    y2: 501.0653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.79,525.11c0-21.19,8.28-41.69,22.87-57.02v-18.44c-22.9,18.19-36.54,46.23-36.54,75.46v27.36h13.66   V525.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.4975,
    y1: 438.9872,
    x2: 441.813,
    y2: 438.9872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "441.81,451.25 441.81,434.14 428.07,426.72 415.5,433.73 415.5,450.95 428.18,443.97  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6479,
    y1: 501.036,
    x2: 506.2555,
    y2: 501.036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M492.59,552.48h13.66v-27.36c0-29.26-13.66-57.33-36.61-75.52v18.42c14.64,15.34,22.95,35.87,22.95,57.1   V552.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.6263,
    y1: 494.6923,
    x2: 594.7646,
    y2: 494.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M590.09,482.74c-15.91,8.28-26.47,24.28-26.47,24.28c16.72-15.14,31.14-21.58,31.14-21.58   C594.67,483.09,592.17,481.66,590.09,482.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.7227,
    y1: 494.6923,
    x2: 553.861,
    y2: 494.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M527.39,482.74c-2.08-1.08-4.58,0.35-4.67,2.69c0,0,14.42,6.44,31.14,21.58   C553.86,507.01,543.3,491.02,527.39,482.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.2941,
    y1: 552.2986,
    x2: 565.3126,
    y2: 552.2986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M565.29,536.34l-0.01-5.02l-1.8,1.26c-1.33,0.93-2.88,1.42-4.51,1.42c-1.63,0-3.19-0.5-4.52-1.43l-1.76-1.24   v4.98l0,18.04c0,3.48-2.82,6.3-6.3,6.3l-196.09,0.02l0.03,12.59l202.35,0v0.02l6.33-0.02l0,0c3.48,0,6.3-2.82,6.3-6.3v-6.3h-0.04   L565.29,536.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.1429,
    y1: 531.4656,
    x2: 649.7059,
    y2: 531.4656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2399,
    style: {
      stopColor: "#F49321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    style: {
      stopColor: "#EC912A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#E18F39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#D18D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    style: {
      stopColor: "#BD8A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    style: {
      stopColor: "#A58672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B8579"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M648.71,528.47c-0.12-5.28-2.74-10.18-7.05-13.22l-32.51-21.65c-1.06-1.01-2.27-1.8-3.57-2.38v0   c-3.22-2.14-7.43-2.09-10.59,0.13l-0.47,0.33c-0.42,0.23-0.85,0.46-1.26,0.74l-2.62,1.84l-25.4,17.84l-6.28,4.4l-6.31-4.44   l-27.97-19.65c-5.7-4-13.55-2.63-17.54,3.05l40.87,28.73l4.67,3.27l3.57,2.52c1.62,1.14,3.78,1.14,5.41,0.01l3.6-2.52l4.64-3.27   l25.28-17.76c3.16-2.22,7.36-2.28,10.58-0.14l23.31,15.48c4.3,3.02,6.92,7.91,7.06,13.17l0.98,38.31l12.59-0.03L648.71,528.47z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed9d0051e8ad87b075905045ca6190f1.svg";
export { ForwardRef as ReactComponent };